import React from 'react';
import CookieSettingsButton from '../consent/CookieSettingsButton';

export default function IvoriSiteFooter() {
  const handleHomeClick = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleMarketplaceClick = (e) => {
    e.preventDefault();
    document.getElementById('marketplace')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="ivori-landing-footer">
      <div className="ivori-landing-footer-inner">
        <div className="ivori-landing-footer-brand">IVORI</div>
        <nav className="ivori-landing-footer-nav">
          <a href="https://ivorilab.com" target="_blank" rel="noopener noreferrer">
            IVORI Lab
          </a>
          <a href="https://ivoriai.com/" target="_blank" rel="noopener noreferrer">
            ivoriai.com
          </a>
          <a href="#marketplace" onClick={handleMarketplaceClick}>
            Marketplace
          </a>
          <a href="#top" onClick={handleHomeClick}>
            Home
          </a>
          <CookieSettingsButton />
        </nav>
        <div className="ivori-landing-footer-meta">© 2026 IVORI Lab</div>
      </div>
    </footer>
  );
}
